/**
 * This module contains functions for determining the environment in which the UI is running.
 *
 * Consider migrating this logic to the backend to have a global source of truth for distinguishing QA vs PROD
 *
 * Alternatively, we could specify the environment inside of head.js files, which are selected at deployment time.
 * This would still be a UI only override.
 * 
 * You can look for other invironments by creating functions like this
    export function isUiInternal() {
      const hostname = window.location.hostname.toLowerCase()
      return hostname.endsWith('contsec.com') || hostname.endsWith('contsec.jp')
    }
 */

/**
 * @returns true if Team Server is currently running locally for Development
 */
export function isUiDev() {
  const hostname = window.location.hostname.toLowerCase()
  return hostname.endsWith('localhost') || hostname === '127.0.0.1'
}
